import API from 'services/api'
export default class Profile extends API {
	async getProfile({
		onEnd = () => { },
		onError = () => { },
		onStart = () => { },
		onSuccess = () => { },
	}) {
		onStart()
		try {
			const options = {
				url: `users/profile`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	// update profile info
	async updateProfile({
		onEnd = () => { },
		onError = () => { },
		onStart = () => { },
		onSuccess = () => { },
	}) {
		onStart()
		try {
			const options = {
				url: `users/update-profile`,
				method: "POST"
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	// sessions list
	async getProfileSessions({
		onEnd = () => { },
		onError = () => { },
		onStart = () => { },
		onSuccess = () => { },
		params = {},
	}) {
		onStart()
		try {
			const { page_size, page } = params
			const options = {
				url: `users/sessions/?${page ? '&page=' + page : ''}${page_size ? '&page_size=' + page_size : ''}`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}

	// get card data
	async getCardData({
		onEnd = () => { },
		onError = () => { },
		onStart = () => { },
		onSuccess = () => { },
		params = {},
	}) {
		onStart()
		try {
			const { page_size, page } = params
			const options = {
				url: `payments/cards/?${page ? '&page=' + page : ''}${page_size ? '&page_size=' + page_size : ''}`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	// create card data
	async createCardData({
		data,
		onEnd = () => { },
		onError = () => { },
		onStart = () => { },
		onSuccess = () => { },
	}) {
		onStart()
		try {
			const options = {
				data,
				method: 'POST',
				url: `payments/cards/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	// delete card data
	async deleteCardData({
		onEnd = () => { },
		onError = () => { },
		onStart = () => { },
		onSuccess = () => { },
		params = {},
	}) {
		onStart()
		try {
			const { id } = params
			const options = {
				method: 'DELETE',
				url: `payments/cards/${id}/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
}